<ng-container *ngIf="layoutVars || layoutVarsResponse">
  <div class="row">
    <div class="col-md-8 mx-auto">
      <a [href]="env">
        <img [src]="layoutVars && layoutVars.logoUrl ? layoutVars.logoUrl : './assets/images/logo/logo-arremaq-superbid.png'" class="logo"
          height="48" />
      </a>
    </div>
  </div>


  <div class="card o-hidden" [@animate]="{value:'*',params:{y:'120px',opacity:'0',delay:'100ms', duration: '400ms'}}">
    <div class="row">
      <div class="col-md-10 mx-auto">
        <div class="row">
          <div class="col-md-12 mt-4 mb-4" *ngIf="loading">
            <h4 class="text-center text-uppercase">Aguarde enquanto verificamos suas credenciais</h4>
            <app-loader [loading]="loading" [small]="true"></app-loader>
          </div>


          <div class="col-md-12 mt-4 mb-4" *ngIf="optinResponse?.success">
            <h4 class="text-center text-uppercase">Credenciais validadas</h4>
            <p class="text-left">Suas credenciais foram validadas com sucesso. Aguarde enquanto redirecionamos para a plataforma de máquinas.</p>
            <app-loader [loading]="true" [small]="true"></app-loader>
          </div>

          <div class="col-md-12 mt-4 mb-4" *ngIf="authError">
            <h4 class="text-center text-uppercase">Houve um problema com sua autenticação</h4>
            <p class="text-left">
              Infelizmente não foi possível validar suas credenciais, por favor entre em contato com o suporte<span *ngIf="authErrorMsg"> e informe a mensagem de erro abaixo</span>.
              <span *ngIf="authErrorMsg"><br/>{{authErrorMsg}}</span>
            </p>
            
          </div>

          <div class="col-md-12 mt-4 mb-4" *ngIf="optinResponse?.errorCode === 'UNAUTHORIZED'">
            <h4 class="text-center text-uppercase">Credenciais inválidas</h4>
            <p class="text-left">Infelizmente suas credenciais não permitem acesso a esta plataforma. Entre em contato com o suporte.</p>
          </div>

          <div class="col-md-12 mt-4 mb-4" *ngIf="optinResponse?.errorCode === 'INCOMPLETE_INFO' && optinResponse?.missingFields === undefined">
            <h4 class="text-center text-uppercase">Dados incompletos</h4>
            <p class="text-left">Os dados fornecidos estão incompletos. Por favor, entre com contato com o suporte.</p>
          </div>
          <ng-container *ngIf="optinResponse?.errorCode === 'MISSING_OPTIN' || (optinResponse?.errorCode === 'INCOMPLETE_INFO' && optinResponse?.missingFields?.length > 0)">
            <div class="col-md-12">
              <h4 class="text-center text-uppercase">Aceite dos termos de uso</h4>
              <p class="text-left">Por favor, confirme que aceita nossos termos de uso abaixo para continuar:</p>
            </div>
            <div class="col-md-12">
              <form (ngSubmit)="optinForm.form.valid && submitOptinAccepted()" #optinForm="ngForm">

                <mat-form-field *ngIf="isMissingField('NAME')">
                  <label>Nome</label>
                  <input matInput [(ngModel)]="name" [required]="isMissingField('NAME')" #nameField="ngModel" name="nameField">
                  <mat-error *ngIf="nameField?.errors?.required">Campo obrigatório</mat-error>
                </mat-form-field>
                <mat-form-field *ngIf="isMissingField('EMAIL')">
                  <label>E-mail</label>
                  <input matInput [(ngModel)]="email" [required]="isMissingField('EMAIL')" #emailField="ngModel" name="emailField" email>
                  <mat-error *ngIf="emailField?.errors?.required">Campo obrigatório</mat-error>
                  <mat-error *ngIf="emailField?.errors?.email">Preencha com um e-mail válido.</mat-error>
                </mat-form-field>
                <mat-form-field *ngIf="isMissingField('CPF')">
                  <label>CPF</label>
                  <input matInput [(ngModel)]="cpf" [required]="isMissingField('CPF')" #cpfField="ngModel" name="cpfField" app-cpf-validator type="phone" [textMask]="cpfMask">
                  <mat-error *ngIf="cpfField?.errors?.required">Campo obrigatório</mat-error>
                  <mat-error *ngIf="cpfField?.errors?.cpf">CPF inválido. Verifique e preencha novamente.</mat-error>
                </mat-form-field>

                <mat-checkbox name="acceptedDealerTermsCheckbox" #acceptedDealerTermsCheckbox="ngModel"
                  [(ngModel)]="acceptedDealerTerms" *ngIf="layoutVars?.personalizedTermsCTA && layoutVars?.personalizedTermsUrl">
                  <a [href]="layoutVars.personalizedTermsUrl" class="pointer-hover underline" target="_blank">{{layoutVars.personalizedTermsCTA}}</a>
                </mat-checkbox>
                <mat-checkbox name="acceptedTermsCheckbox" #acceptedTermsCheckbox="ngModel" [(ngModel)]="acceptedTerms">
                  Li e concordo com os <a (click)="openTermsConditionsModal()" class="pointer-hover underline">termos e condições de uso</a> da plataforma Arremaq.
                </mat-checkbox>
                <mat-checkbox name="acceptedDealerInfoCheckbox" #acceptedDealerInfoCheckbox="ngModel"
                  [(ngModel)]="acceptedDealerInfo">
                  Estou ciente de que os dados pessoais e das negociações preenchidas por mim serão compartilhados com a
                  <strong>{{layoutVars?.name ? layoutVars.name : 'Arremaq'}}</strong>.
                </mat-checkbox>
                <div class="mt-16 mb-32">
                  <button class="btn btn-primary btn-block" [disabled]="!isFormValid() || savingOptin">
                    <div class="btn-spinner float-left" *ngIf="savingOptin"></div>
                    CONTINUAR
                  </button>
                </div>
              </form>
            </div>
          </ng-container>
        </div>
      </div>
    </div>
  </div>
</ng-container>